import { BadgeProps } from "@abb/arcadia-ui-react/build/components/badge/types"

const FILLED_SQUARE_BADGE_VARIANT = "filled-square-badge"

export function getNotificationStatusProps(
  status: "active" | "expired" | "planned"
): BadgeProps {
  const normalized = status.toLowerCase()

  switch (normalized) {
    case "active":
      return {
        label: "Active",
        status: "positive",
        variant: FILLED_SQUARE_BADGE_VARIANT,
        leadingIconName: "icon_abb_dias icon-abb_alert-bell-notification-1",
      }

    case "planned":
      return {
        label: "Planned",
        status: "warning",
        variant: FILLED_SQUARE_BADGE_VARIANT,
        leadingIconName: "icon_abb_dias icon-abb_refresh",
      }

    case "expired":
      return {
        label: "Expired",
        status: "negative",
        variant: FILLED_SQUARE_BADGE_VARIANT,
        leadingIconName: "icon_abb_dias icon-abb_alarm-bell_disable",
      }

    default:
      return {
        label: status,
        status: "neutral",
        variant: FILLED_SQUARE_BADGE_VARIANT,
      }
  }
}
